import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Award, ClipboardCheck } from 'lucide-react';
import { Badge, Button, EmptyState, LoadingState, SectionHeading } from '../components/ui';
import { loadAllMyResults, type ResultRow } from '../lib/studentUtilities';

export function StudentResultsHistory() {
  const [results, setResults] = useState<ResultRow[]>();
  useEffect(() => { let active = true; void loadAllMyResults().then((rows) => { if (active) setResults(rows); }); return () => { active = false; }; }, []);
  if (!results) return <LoadingState />;
  return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon"><Award size={28} /></div><div><h1>Results</h1><p>Every exam attempt you have submitted.</p></div></section>
    <section className="detail-section">
      <SectionHeading title={`Attempted · ${results.length}`} />
      {results.length ? <div className="subject-list">{results.map((result) => <Link className="subject-row" key={result.objectId} to={`/tests/result/${result.objectId}`}>
        <span><ClipboardCheck size={17} /></span>
        <div><strong>{result.TestTitle ?? 'Test'}</strong>
          <small>{result.CourseTitle ?? 'AyurGuide'} · {formatResultDate(result.TestDate)}</small></div>
        <Badge tone={Number(result.Percentage ?? 0) >= 60 ? 'green' : Number(result.Percentage ?? 0) >= 40 ? 'teal' : 'red'}>{Number(result.Percentage ?? 0)}%</Badge>
      </Link>)}</div>
      : <EmptyState icon={ClipboardCheck} title="No attempts yet" description="Start a test in exam mode and your scored results will collect here." action={<Link to="/tests"><Button variant="soft">Browse tests</Button></Link>} />}
    </section>
  </div>;
}

function formatResultDate(value?: string) {
  if (!value) return 'Date unavailable';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Date unavailable' : date.toLocaleDateString('en-IN');
}
